import { z } from 'zod'
import { Model } from './architecture'

export const NameValidation = z.object({
  value: z.string({ required_error: '[Name] value is required' }),
})

export class Name extends Model {
  static create({ value }: z.infer<typeof NameValidation>) {
    NameValidation.parse({ value })
    return new Name(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
